import {GridList} from 'shells/grid-list/grid-list';

import {ExplorePageSectionHeader} from '../explore-page-section-header';

import {ProductUpdateCard} from './product-update-card';
import {PRODUCT_UPDATES} from './product-updates';

export const ProductUpdatesSection = () => {
    return (
        <div className='flex flex-dir-col gap-16'>
            <ExplorePageSectionHeader
                title='Recent product updates'
                cta={{
                    text: 'See all updates',
                    onClick: () => {
                        window.open('https://www.nutshell.com/product-updates', '_blank');
                    },
                }}
            />
            <GridList numColumns={3}>
                {PRODUCT_UPDATES.map((productUpdate) => (
                    <ProductUpdateCard key={productUpdate.title} productUpdate={productUpdate} />
                ))}
            </GridList>
        </div>
    );
};
